export enum Settings {
  CLICK_SETTING_TAB = 'click_setting_tab',
  SAVE_SETTINGS = 'save_settings',
  REVERT_SETTINGS = 'revert_settings',
}
